export default {"src":"/_next/static/media/plus.690dda76.svg","height":24,"width":24};